import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { formatThaiShortDateTwoDigitYear } from 'common/utils/date'
import { useSpeciesName } from 'modules/pond/api/selector'
import { Cycle } from 'modules/shrimpTopup/api/types'

type Props = {
  cycleData: Cycle | null
}
const ShrimpTopupRecordBodyCycle: React.FC<Props> = ({ cycleData }) => {
  const { t } = useTranslation('shrimpTopup')
  const navigate = useNavigate()
  const location = useLocation()
  const species = useSpeciesName()

  const handleCardClick = () => {
    const newPath = location.pathname.split('/topup')[0]
    navigate(newPath + '/setting')
  }

  return (
    <Grid item sm={12} md={6} xl={3}>
      <Card
        onClick={handleCardClick}
        sx={{
          width: '100%',
          backgroundColor: '#FFF9C4',
          borderRadius: { xs: 1, sm: 2 },
          transition: 'transform 0.3s ease',
          cursor: 'pointer',
        }}>
        <CardContent sx={{
          p: { xs: 1.5, sm: 2 }
        }}>
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.startDate')}

                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {formatThaiShortDateTwoDigitYear(cycleData?.startDate ?? null)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ my: 0.5 }} />
              </Grid>
              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.salinity')}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {cycleData?.salinity} ppt
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ my: 0.5 }} />
              </Grid>
              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.breedCondition', { species })}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {cycleData?.breedName}
                </Typography>
              </Grid>

              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.brandName', { species })}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {cycleData?.brandName}
                </Typography>
              </Grid>

              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.breedProductName', { species })}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {cycleData?.breedProductName}
                </Typography>
              </Grid>

              <Grid item xs={7}>
                <Typography variant="body2" component="div" fontWeight="bold">
                  {t('topup.initialShrimpCount', { species })}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body2" align="right">
                  {cycleData?.initialShrimpCount ?? '0'} {t('topup.unit')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default ShrimpTopupRecordBodyCycle
